import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { func, instanceOf } from 'prop-types';
import { withRouter } from 'react-router';
import DeButton from '../../shared/DeButton';
import * as urls from '../../../../actions/urlTypes';
import { setTargetDistribute } from '../../../../actions/deActions/deDistributeActions';

const LabelActions = ({ exportTarget, router }) => {
  const dispatch = useDispatch();
  const impersonated = useSelector(state => state.login.loginResponse.data.impersonated);
  const target = useSelector(state => state.deLabel.selectedTargets);
  const _handleDistributeClick = () => {
    dispatch(setTargetDistribute(target));
    router.push(`${urls.APP_ROOT_URL}/datahub/distribute`)
  };
  return (
    <div className="de--createNew--actions">
      <DeButton
        label="Distribute"
        onClick={() => _handleDistributeClick()} // Distribute label
        outline
        fill="secondary"
        disabled={!target || impersonated}
      />
      <DeButton
        label="Export"
        onClick={() => exportTarget()}
        fill="secondary"
        disabled={!target || impersonated}
      />
    </div>
  );
};

LabelActions.propTypes = {
  exportTarget: func,
  router: instanceOf(Object)
};

export default withRouter(LabelActions);
